import { render } from "./BindingAdd.vue?vue&type=template&id=87763b08&scoped=true"
import script from "./BindingAdd.vue?vue&type=script&lang=js"
export * from "./BindingAdd.vue?vue&type=script&lang=js"

import "./BindingAdd.vue?vue&type=style&index=0&id=87763b08&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87763b08"]])

export default __exports__